import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { confirmAlert } from 'react-confirm-alert';

/* JS */
import * as Server from 'assets/js/Server';
import * as Common from 'assets/js/Common';

/* 컴포넌트 */
import ProductSearchForm from 'components/product/ProductSearchForm';

const Retrieval = () => {
  const [productMstList, setProductMstList] = useState([{
    productSeq: 0,
    fkProductType: '',
    productType: '',
    fkProductKind: '',
    productKind: '',
    fkWarehouse: '',
    warehouse: '',
    productName: '',
    fkProductUnit: '',
    productUnit: '',
    productStatus: '',
    regDate: '',
    defaultQuantity: 0,
    currentQuantity: 0,
    useQuantity: 0,
  }]);
  const [custMstList, setCustMstList] = useState([{
    custMstSeq: 0,
    custName: '',
  }]);
  const [search, setSearch] = useState({
    productName: '',
    warehouseSeq: '',
    productTypeMstSeq: '',
    productKindSeq: '',
  });

  useEffect(() => {
    Common.isLogin();

    getCustMstList();
    getProductMstList();
  }, []);

  const getCustMstList = () => {
    Server.sendGet('client/management', {}, getCustMstListCallback).then();
  };

  const getCustMstListCallback = res => {
    setCustMstList(res?.['resultList']);
  };

  const getProductMstList = () => {
    Server.sendGet('product/mst', search, getProductMstListCallback).then();
  };

  const getProductMstListCallback = res => {
    res?.['resultList'].map(v => v.useQuantity = 0);

    setProductMstList(res?.['resultList']);
  };

  const handleClientChange = (index, value) => {
    const updatedList = productMstList.map((item, idx) => {
      if (idx === index) {
        return {
          ...item,
          custMstSeq: value,
        };
      }
      return item;
    });

    setProductMstList(updatedList);
  };

  const handleQuantityChange = (index, value) => {
    const updatedList = productMstList.map((item, idx) => {
      if (idx === index) {
        return {
          ...item,
          useQuantity: parseInt(value),
        };
      }
      return item;
    });

    setProductMstList(updatedList);
  };

  const handleRetrieval = item => {
    if (item.useQuantity === 0) {
      Common.errorMsg('Retrieval Quantity required.');

      return false;
    }

    if (Common.isEmpty(item.custMstSeq)) {
      Common.errorMsg('Client required.');

      return false;
    }

    confirmAlert({
      title: 'Are you sure you want to save?',
      buttons: [{
        label: 'Yes',
        onClick: () => {
          Server.sendPost('product/mst/retrieval', item, retrievalCallback).then();
        }
      }, {
        label: 'No'
      }]
    });
  };

  const retrievalCallback = () => {
    Common.alertSuccess();

    getProductMstList();
  };

  return (
    <>
      <Inner>
        <Title>
          <TitHead>
            <i/>
            <h4>Product retrieval</h4>
          </TitHead>
        </Title>
        <ProductSearchForm
          search={search}
          setSearch={setSearch}
          getList={getProductMstList}
        />
        <Content>
          <Table>
            <colgroup>
              <col width='10%'/>
              <col width='10%'/>
              <col width='15%'/>
              <col width='15%'/>
              <col width='10%'/>
              <col width='15%'/>
              <col width='15%'/>
              <col width='10%'/>
            </colgroup>
            <thead>
            <tr>
              <th>Warehouse</th>
              <th>Product Type</th>
              <th>Product Kind</th>
              <th>Product Name</th>
              <th>Current Quantity</th>
              <th>Retrieval Quantity</th>
              <th>Client</th>
              <th>Action</th>
            </tr>
            </thead>
            <tbody>
            {productMstList?.map((item, idx) => (
              <tr key={idx}>
                <td>{item.warehouse}</td>
                <td>{item.productType}</td>
                <td>{item.productKind}</td>
                <td>{item.productName}</td>
                <td>{item.currentQuantity}</td>
                <td>
                  <input
                    type='text'
                    id='quantity'
                    name='quantity'
                    value={item?.useQuantity}
                    onChange={e => {
                      e.target.value = Common.onlyNumber(e.target.value);

                      if (item.currentQuantity < parseInt(e.target.value)) {
                        Common.errorMsg('outnumber the current quantity');

                        e.target.value = '0';
                      }

                      handleQuantityChange(idx, e.target.value);
                    }}
                  />
                </td>
                <td>
                  <select
                    name='workForm'
                    id='workForm'
                    value={search?.fkCustMstSeq}
                    onChange={e => {
                      handleClientChange(idx, e.target.value);
                    }}
                  >
                    <option value={''}>--Select--</option>
                    {custMstList?.map(item => (
                      <option key={item.custMstSeq} value={item.custMstSeq}>{item.custName}</option>
                    ))}
                  </select>
                </td>
                <td>
                  {item.currentQuantity !== 0 &&
                    <TitBtn onClick={() => handleRetrieval(item)}>
                      <span>Retrieval</span>
                    </TitBtn>
                  }
                </td>
              </tr>
            ))}
            {Common.isEmpty(productMstList) &&
              <tr>
                <td colSpan={7} className={'none-data'}>
                  There is no data to output.
                </td>
              </tr>
            }
            </tbody>
          </Table>
        </Content>
      </Inner>
    </>
  );
}

const Inner = styled.div`
  flex: 1;
  background: #ffffff;
`;

const Title = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
`;

const TitHead = styled.div`
  display: flex;
  align-items: center;
  gap: 0 10px;

  & i {
    display: block;
    width: 4px;
    height: 32px;
    border-radius: 0 2px 2px 0;
    background: #1e1e1e;
  }

  & h4 {
    font-weight: 500;
    font-size: 16px;
    color: #000000;
  }
`;

const TitBtn = styled.button`
  height: 40px;
  line-height: 40px;
  padding: 0 15px;
  display: flex;
  align-items: center;
  gap: 0 5px;
  background: ${props => (props['$Color'] ? '#0072b9' : '#a4a4a4')};
  border-radius: 5px;
  margin: auto;

  & span {
    font-weight: 500;
    font-size: 14px;
    color: #ffffff;
  }

  &:hover {
    background-color: ${props => (props['$Color'] ? '#075C97' : '#7e7e7e')};
  }
`;

const SearchArea = styled.div`
  position: relative;
  margin-top: 35px;
  padding: 15px 20px;
  border-top: 1px solid #eeeeee;
  border-bottom: 1px solid #eeeeee;
  display: flex;
  align-items: center;
  gap: 0 15px;
  width: 100%;

  & .react-datepicker__tab-loop {
    position: absolute;
  }
`;

const CateIn = styled.div`
  display: flex;
  align-items: center;
  gap: 0 20px;
`;

const Cate = styled.div`
  display: flex;
  align-items: center;
  gap: 0 10px;

  & label {
    font-weight: 400;
    font-size: 16px;
    color: #777777;
  }
`;

const CateInput = styled.input`
  width: 160px;
  height: 40px;
  line-height: 40px;
  padding: 0 16px;
  font-weight: 400;
  font-size: 16px;
  color: #777777;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 5px;
  outline: none;
`;

const SearchBtn = styled.button`
  width: 120px;
  height: 40px;
  line-height: 40px;
  border-radius: 5px;
  background: #a4a4a4;
  font-weight: 400;
  font-size: 16px;
  color: #ffffff;

  &:hover {
    background-color: #7e7e7e;
  }
`;

const Content = styled.div`
  margin-top: 35px;
  position: relative;
  height: 622px;
  overflow-y: scroll;
`;

const Table = styled.table`
  position: relative;

  & th {
    padding:15px 0;
    font-weight: 400;
    font-size: 18px;
    color: #777777;
    background: #f8f8f8;
    text-align: center;
    border-bottom: 1px solid #eeeeee;
    vertical-align: middle;
  }

  & td {
    padding: 10px 0;
    font-weight: 400;
    font-size: 16px;
    color: #000000;
    text-align: center;
    vertical-align: middle;
    border-bottom: 1px solid #eeeeee;
    border-left: 1px solid #eeeeee;

    & input {
      width: 80%;
      height: 40px;
      line-height: 40px;
      padding: 0 16px;
      font-weight: 400;
      font-size: 16px;
      color: #777777;
      border: 1px solid rgba(0, 0, 0, 0.12);
      border-radius: 5px;
      outline: none;
    }
    
    & select {
      width: 80%;
      height: 40px;
      line-height: 40px;
      padding: 0 16px;
      font-weight: 400;
      font-size: 16px;
      color: #777777;
      background: #f8f8f8 url('https://ust-india.s3.ap-northeast-2.amazonaws.com/erp-web/sel_arrow.svg') top 50% right 10px no-repeat;
      border: 1px solid rgba(0, 0, 0, 0.12);
      border-radius: 5px;
      outline: none;
    }
  }

  & thead {
    position: sticky;
    top: 0;
  }

  & tbody > tr {
    cursor: pointer;

    &:hover {
      & td {
        background: #f4f4f4;
      }
    }
  }

  & tr td.none-data {
    height: 572px;
    border: 0;
  }

  & tr td:first-child {
    border-left: none;
  }

  & tr:nth-child(even) {
    background: #fcfcfc;
  }
`;

export default Retrieval;